import React, { useState, useContext, useEffect } from "react";
import { useRoutes } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { useQuery } from "@apollo/client";
import Layout from "./Layout/Layout";
import Login from "./Pages/Login";
import Users from "./Pages/Users";
import Report from "./Pages/Report"; 
import Income from "./Pages/Income";
import Student from "./Pages/Student";
import Invoice from "./Pages/Invoice";
import Setting from "./Pages/Setting";
import Page404 from "./Pages/Page404";
import Customer from "./Pages/Customer";
import SetUpFee from "./Pages/SetUpFee";
import Dashboard from "./Pages/Dashboard";
import { GET_USER_LOGIN } from "./Schema/User";
import Disbursement from "./Pages/Disbursement";
import SetUpGroupFee from "./Pages/SetUpGroupFee";
import SetUpSupplier from "./Pages/SetUpSupplier";
import SchoolService from "./Pages/SchoolService"; 
import SetUpListItem from "./Pages/SetUpListItem";
import GeneralIncome from "./Pages/GeneralIncome";
import { AuthContext } from "./Context/AuthContext";
import ChartOfAccount from "./Pages/ChartOfAccount";
import SetUpIncomeHead from "./Pages/SetUpIncomeHead";
import PayDisbursement from "./Pages/PayDisbursement";
import SetUpExspenseType from "./Pages/SetUpExspenseType";
import SetUpExspenseGroup from "./Pages/SetUpExspenseGroup";
import StudStatisti from "./Components/Report/StudStatisti";
import IncomeReport from "./Components/Report/IncomeReport";
import TuitionReport from "./Components/Report/TuitionReport";
import ToPayInvoice from "./Pages/ToPayInvoice";
import ChangePwAfterResetPw from "./Pages/ChangePwAfterResetPw";
import StudentDetails from "./Components/Student/StudentDetails";
import DisburmentReport from "./Components/Report/DisburmentReport";
import StudentPaymentMainTab from "./Components/Report/StudentPaymentMainTab";

export default function Router({ prefersDarkMode, setPrefersDarkMode }) {
  const { state } = useContext(AuthContext);

  // ========================= get user login =======================
  useQuery(GET_USER_LOGIN, {
    variables: {
      client: "Accounting",
    },
    onCompleted: ({ getUserLogin }) => {
      if (getUserLogin) {
        window.localStorage.setItem("userLogin", JSON.stringify(getUserLogin));
      }
    },
    fetchPolicy: "network-only",
  });

  // ====================== check state user login ==========================
  const [token, setToken] = useState(
    JSON.parse(window.localStorage.getItem("token"))
  );

  useEffect(() => {
    async function checkUser() {
      let userToke = await JSON.parse(window.localStorage.getItem("token"));

      if (userToke) {
        setToken(userToke);
        return;
      }

      if (state?.user?.token !== null && state?.user?.token !== undefined) {
        setToken(state?.user?.token);
        window.localStorage.setItem(
          "token",
          JSON.stringify(state?.user?.token)
        );
      } else {
        setToken(null);
      }
    }

    setTimeout(() => {
      checkUser();
    }, 2000);
  }, [state?.user]);

  const userLogin = JSON.parse(window.localStorage.getItem("userLogin"));
  // console.log("userLogin::", userLogin)

  // End check Route ==========================================================================

  const LoginPage = useRoutes([
    { path: "/", element: <Login /> },
    { path: "/login", element: <Login /> },
    // { path: "/forgotpassword", element: <ForgotPassword /> },
    { path: "*", element: <Login /> },
  ]);

  const ChangePwWhenResetPw = useRoutes([
    { path: "/", element: <ChangePwAfterResetPw /> },
    { path: "change-password-after-reset", element: <ChangePwAfterResetPw /> },
    { path: "*", element: <ChangePwAfterResetPw /> },
  ]);

  const Content = useRoutes([
    {
      path: "/",
      element: ( 
        <Layout
          to="/dashboard"
          prefersDarkMode={prefersDarkMode}
          setPrefersDarkMode={setPrefersDarkMode}
        />
      ),
      children: [
        { path: "/", element: <Navigate to="/dashboard" /> },
        { path: "/income", element: <Income /> },

        { path: "/report", element: <Report /> },
        { path: "/student", element: <Student /> },
        { path: "dashboard", element: <Dashboard /> },
        { path: "/disbursement", element: <Disbursement /> },
        { path: "/generalincome", element: <GeneralIncome /> }, 
        { path: "/school-service", element: <SchoolService /> },
        { path: "/pay-disbursement", element: <PayDisbursement /> },
        { path: "/students/student-detail", element: <StudentDetails /> },
        {
          path: "send-notification",
          element: <ToPayInvoice />,
        },
        {
          path: "invoice",
          element: <Invoice />,
        },

        { path: "setting", element: <Setting /> },
        {
          path: "/setting/exspense-group",
          element: <SetUpExspenseGroup />,
        },
        {
          path: "/report/income-report",
          element: <IncomeReport />,
        },
        {
          path: "/report/student-payment-report",
          element: <StudentPaymentMainTab />,
        },
        {
          path: "/report/student-tuition-report",
          element: <TuitionReport />,
        },
        {
          path: "/report/student-statistic-by-academic-year",
          element: <StudStatisti />,
        },
        {
          path: "/report/disbursement-report",
          element: <DisburmentReport />,
        },
        {
          path: "/setting/exspense-type",
          element: <SetUpExspenseType />,
        },
        {
          path: "/setting/chart-of-account",
          element: <ChartOfAccount />,
        },
        {
          path: "/setting/users",
          element: <Users />,
        },
        {
          path: "/setting/supplier",
          element: <SetUpSupplier />,
        },
        {
          path: "/setting/fee",
          element: <SetUpFee />,
        },
        {
          path: "/setting/gruop-fee",
          element: <SetUpGroupFee />,
        },
        {
          path: "/setting/head-income",
          element: <SetUpIncomeHead />,
        },
        {
          path: "/setting/list-item",
          element: <SetUpListItem />,
        },
        {
          path: "/setting/customer",
          element: <Customer />,
        },
        { path: "*", element: <Page404 /> },
      ],
    },
  ]);

  if (userLogin?.isChangedDefaultPassword === false && token) {
    return ChangePwWhenResetPw;
  } else if (userLogin?.isChangedDefaultPassword && token) {
    return Content;
  } else {
    return LoginPage;
  }
}
